/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S5_Li3Inputs */

const tr_onbilgi_s5_li3 = /** @type {(inputs: Onbilgi_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erişim, e-posta ve şifre ile Platform girişi üzerinden sağlanır.`)
};

const en_onbilgi_s5_li3 = /** @type {(inputs: Onbilgi_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access is provided through the Platform login with email and password.`)
};

const de_onbilgi_s5_li3 = /** @type {(inputs: Onbilgi_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Zugang erfolgt über die Anmeldung an der Plattform mit E-Mail und Passwort.`)
};

const ru_onbilgi_s5_li3 = /** @type {(inputs: Onbilgi_S5_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ предоставляется через вход на Платформу с использованием электронной почты и пароля.`)
};

/**
* | output |
* | --- |
* | "Access is provided through the Platform login with email and password." |
*
* @param {Onbilgi_S5_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s5_li3 = /** @type {((inputs?: Onbilgi_S5_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S5_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s5_li3(inputs)
	if (locale === "de") return de_onbilgi_s5_li3(inputs)
	if (locale === "ru") return ru_onbilgi_s5_li3(inputs)
	return tr_onbilgi_s5_li3(inputs)
});